import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { clsx } from "clsx";
import { MAX_LENGTH, inputClassName } from "../constants.js";
import { getInitialCharacterCount } from "../utils/getInitialCharacterCount.js";
const InputElement = /*#__PURE__*/ forwardRef(({ size, inputState, id, label, showCharactersCount = false, maxLength = MAX_LENGTH, ...inputProps }, ref)=>{
    const [characterCount, setCharacterCount] = useState(getInitialCharacterCount(inputProps));
    const handleInputChange = (event)=>{
        const { onChange } = inputProps;
        if (onChange) onChange(event);
        if (!showCharactersCount) return;
        const { value } = event.target;
        setCharacterCount(value.length);
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx("input", {
                ref: ref,
                id: id,
                "aria-errormessage": `${id}Error`,
                "aria-invalid": 'error' === inputState,
                "aria-label": inputProps['aria-label'] ?? label,
                maxLength: maxLength,
                ...inputProps,
                className: clsx(inputClassName, inputProps.className),
                onChange: handleInputChange
            }),
            showCharactersCount && /*#__PURE__*/ jsxs("span", {
                className: clsx('tw-font-body5 tw-mr-1.2', 'disabled' === inputState ? 'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-400'),
                children: [
                    characterCount,
                    "/",
                    maxLength
                ]
            })
        ]
    });
});
InputElement.displayName = 'InputElement';
const components_InputElement = InputElement;
export default components_InputElement;
export { InputElement };
